module.exports = __webpack_public_path__ + "static/media/as.16f433a6.svg";